export var FormItemStatus = {
  SUCCESS: 'success',
  ERROR: 'error'
};